import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse } from 'coreOld/types';
import { getFormData } from 'coreOld/utils';
import { IRank } from 'system/types';

export const getAllRanks = async (signal?: AbortSignal): Promise<GetManyResponse<IRank>> => {
  const { data } = await partfinitiClient.get('/user/rank-list/ranks', signal);

  return mapRecordsFromServer<IRank>(data.data, data.recordsFiltered);
};

export const upsertRank = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/user/rank-edit/save', dataToSend);
};

export const removeRank = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/user/rank-edit/remove', dataToSend);
};
